<template>
  <div class="name">
    <van-nav-bar :title="$t('setname.title')" class="custom-nav-bar">
      <template #left>
        <van-icon name="arrow-left" @click="back()"/>
      </template>
      <template #right>
        <span class="nav-right" @click="save()">{{$t('setname.save')}}</span>
      </template>
    </van-nav-bar>
    
    <div class="content-wrapper">
      <van-cell-group class="custom-cell-group">
        <van-field 
          v-model="name" 
          :readonly="userInfo.name!=null" 
          :label="$t('setname.xingming')" 
          :placeholder="$t('setname.xmpls')" 
          class="custom-field"
        />
      </van-cell-group>
      <!-- <p class="tip-text">{{$t('setname.tips')}}</p> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name:"",
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    save(){
      if(this.userInfo.name){
        this.$toast(this.$t('setname.notreset'));
        return true;
      }
      if(this.name === "" || this.name === null || this.name === undefined){
        this.$toast.fail(this.$t('setname.plsentername'));
        return false;
      }
      this.$http({
        method: 'get',
        data:{name:this.name},
        url: 'user_set_name'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.name = this.userInfo.name;
          this.$toast(res.msg);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){  // 修复这里：添加了缺失的右括号
          console.log(res.data.name)
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Home'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style scoped>
:export {
    gbcolor: linear-gradient(135deg, #3498db, #8e44ad)
}

.name {
    width: 100%;
    min-height: 100vh;
    background: white;
}

/* 顶部导航栏样式 - 填充渐变色 */
.custom-nav-bar {
    height: 3.5rem;
    line-height: 3.5rem;
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    position: relative;
    z-index: 10;
}

.custom-nav-bar::after {
    display: none;
}

.van-nav-bar__title {
    max-width: 60%;
    margin: 0 auto;
    color: white !important;
    font-weight: 600;
    font-size: 1.1rem;
}

.van-nav-bar__left,
.van-nav-bar__right {
    padding: 0 15px;
}

.van-nav-bar__left .van-icon,
.nav-right {
    color: white !important;
    font-size: 1rem;
    font-weight: 500;
}

.nav-right {
    font-size: 0.95rem;
}

/* 内容区域样式 */
.content-wrapper {
    padding: 2rem 1rem;
    position: relative;
    z-index: 1;
    background: white;
}

/* 自定义单元格组 */
.custom-cell-group {
    border-radius: 12px;
    overflow: hidden;
    background: white;
    margin-bottom: 1.5rem;
}

/* 自定义输入框带边框 */
.custom-field {
    padding: 1.2rem 1.2rem;
    background: white;
    border: 1.5px solid #e8e8e8;
    border-radius: 10px;
    margin-bottom: 0;
    transition: all 0.3s ease;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.custom-field:focus-within {
    border-color: #667eea;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
    transform: translateY(-1px);
}

/* 移除默认的单元格组边框 */
.van-cell-group::after,
.van-cell-group::before {
    display: none;
}

.van-field::after {
    display: none;
}

/* 输入框内部样式调整 */
.van-field__label {
    color: #333;
    font-weight: 500;
    font-size: 0.95rem;
    width: 80px;
}

.van-field__body {
    color: #667eea;
    font-weight: 500;
    font-size: 0.95rem;
}

.van-field__control {
    color: #667eea;
    font-weight: 500;
}

.van-field__control::placeholder {
    color: #aaa;
    font-weight: normal;
}

/* 提示文字样式 */
.tip-text {
    color: #dc2037;
    font-size: 0.8rem;
    padding: 1rem 0.5rem;
    text-align: center;
    background: #fff5f5;
    border-radius: 8px;
    border: 1px solid #ffebee;
}

/* 响应式调整 */
@media (max-width: 320px) {
    .content-wrapper {
        padding: 1.5rem 0.8rem;
    }
    
    .custom-field {
        padding: 1rem 1rem;
    }
}

/* 动画效果 */
@keyframes slideIn {
    from { 
        opacity: 0; 
        transform: translateY(20px); 
    }
    to { 
        opacity: 1; 
        transform: translateY(0); 
    }
}

.custom-cell-group {
    animation: slideIn 0.5s ease forwards;
}

/* 只读状态样式 */
.van-field--readonly .van-field__control {
    color: #666;
    background-color: #f8f9fa;
}

.van-field--readonly .van-field__body {
    background-color: #f8f9fa;
}
</style>

